import {
  PREFIX_DF,
  PREFIX_RH,
  PREFIX_T,
  PREFIX_WIND_MAG_KPH
} from '../shared/behaviour_models_utils';
import {calculateDIR} from '../shared/direction';
import {minZero} from '../../point_utils';

export {calculateDIR};

export function calculateFFDI(wd, wind_reduction_factor) {
  const vars = {wind_reduction_factor: wind_reduction_factor || 3};
  const ffdi = calculateFDI(wd, vars);
  return typeof ffdi !== 'undefined' ? parseFloat(ffdi.toFixed(1)) : undefined;
}

export function calculateFDI(wd, vars) {
  const relative_humidity = wd[PREFIX_RH];
  const air_temp = wd[PREFIX_T];
  const wind_speed = wd[PREFIX_WIND_MAG_KPH];
  const drought_factor = wd[PREFIX_DF];
  if (typeof relative_humidity !== 'undefined' &&
      typeof air_temp !== 'undefined' &&
      typeof wind_speed !== 'undefined' &&
      typeof drought_factor !== 'undefined') {
    return minZero(2 * Math.exp(-0.45 + 0.987 * Math.log(drought_factor) - 0.0345 * relative_humidity
                                + 0.0338 * air_temp + 0.0234 * wind_speed * 3 / vars.wind_reduction_factor));
  }
  return undefined;
}

export function calculateFDI_NW(wd) {
  const relative_humidity = wd[PREFIX_RH];
  const air_temp = wd[PREFIX_T];
  const drought_factor = wd[PREFIX_DF];
  if (typeof relative_humidity !== 'undefined' &&
      typeof air_temp !== 'undefined' &&
      typeof drought_factor !== 'undefined') {
    return minZero(2 * Math.exp(-0.45 + 0.987 * Math.log(drought_factor)
                                - 0.0345 * relative_humidity + 0.0338 * air_temp));
  }
  return undefined;
}

export function calculateFROS(wd, vars) {
  const fdi = calculateFDI(wd, vars);
  if (typeof fdi !== 'undefined') {
    return 0.0012 * fdi * vars.fine_fuel_load * Math.exp(0.069 * vars.slope) * 1000;
  }
  return undefined;
}

export function calculateFROS_NS(wd, vars) {
  const fdi_nw = calculateFDI_NW(wd, vars);
  if (typeof fdi_nw !== 'undefined') {
    return 0.0012 * fdi_nw * vars.fine_fuel_load * 1000;
  }
  return undefined;
}

export function calculateFH(wd, vars) {
  const fros = calculateFROS(wd, vars);
  if (typeof fros !== 'undefined') {
    return minZero(13 * fros / Math.exp(0.069 * vars.slope) / 1000 + 0.24 * vars.fine_fuel_load - 2);
  }
  return undefined;
}

export function calculateSD(wd, vars) {
  const fros = calculateFROS(wd, vars);
  if (typeof fros !== 'undefined') {
    return minZero((fros / Math.exp(0.069 * vars.slope) / 1000 *
                    (4.17 - 0.033 * vars.fine_fuel_load) - 0.36) * 1000);
  }
  return undefined;
}

export function calculateFI(wd, vars) {
  const fros = calculateFROS(wd, vars);
  const drought_factor = wd[PREFIX_DF];
  if (typeof fros !== 'undefined' && typeof drought_factor !== 'undefined') {
    return 516.7 * vars.fine_fuel_load * drought_factor / 10 * fros / 1000;
  }
  return undefined;
}

export function calculateHO(wd, vars) {
  const drought_factor = wd[PREFIX_DF];
  if (typeof drought_factor !== 'undefined') {
    return 1860 * vars.fine_fuel_load * drought_factor / 10;
  }
  return undefined;
}

export function calculateSFFM(wd) {
  const relative_humidity = wd[PREFIX_RH];
  const air_temp = wd[PREFIX_T];
  if (typeof relative_humidity !== 'undefined' && typeof air_temp !== 'undefined') {
    return minZero(3.033808 * Math.exp(relative_humidity * (-0.00033169 * air_temp + 0.02638614)));
  }
  return undefined;
}

export function calculateWSF(wd) {
  const wind_speed = wd[PREFIX_WIND_MAG_KPH];
  if (typeof wind_speed !== 'undefined') {
    return wind_speed / 3.0;
  }
  return undefined;
}

export function calculateWSO(wd) {
  const wind_speed = wd[PREFIX_WIND_MAG_KPH];
  if (typeof wind_speed !== 'undefined') {
    return wind_speed / 1.2;
  }
  return undefined;
}



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/mcarthur_mk5/calculations.js